/** Resolve logged-in Hifz user from React state or localStorage (survives navigation) */
export function getEffectiveHifzUser(hifzUser) {
  if (hifzUser?.token && hifzUser?.role) {
    return hifzUser;
  }
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const email = localStorage.getItem("email") || "";
  if (role && token) {
    return { role, token, userId, email };
  }
  return null;
}

export function canAccessQariPortal(hifzUser) {
  const user = getEffectiveHifzUser(hifzUser);
  if (!user?.token) return false;
  return user.role === "qari" || user.role === "admin";
}

export function canAccessStudentPortal(hifzUser, deepLinkToken) {
  if (deepLinkToken) return true;
  const user = getEffectiveHifzUser(hifzUser);
  return user?.role === "student";
}
